module.exports = __webpack_public_path__ + "img/marketea_blanco.c04352fe.svg";